import script from "./LoadingComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./LoadingComponent.vue?vue&type=script&setup=true&lang=js"

import "./LoadingComponent.vue?vue&type=style&index=0&id=43d0e2aa&lang=scss"

const __exports__ = script;

export default __exports__